import React from "react";
import ErrorMessage from "components/common/ErrorMessage";
import { ElementState, Preview } from "@creatomate/preview";
import SubtitleTitle from "./SubtitleTitle";
import BurnSubtitleOption from "./menu/BurnSubtitleOption";
import SubtitleMenu from "./menu/SubtitleMenu";
import AnimationButton from "../../animation/AnimationButton";
import AnimationBackButton from "../../animation/AnimationBackButton";

interface SubtitleHeaderProps {
  availableLanguages: string[];
  activeLanguageCode?: string;
  preview: Preview;
  subtitlesOn: boolean;
  burnSubtitles: boolean;
  showStyles: boolean;
  showAnimations: boolean;
  showLanguageOptions: boolean;
  changingLanguage: boolean;
  activeElement: ElementState;
  error?: string;
  setShowAnimations: (value: boolean) => void;
  onBackStyles: () => void;
  onLanguageChange: (language: string) => void;
  onSelectTranslation: (value: boolean) => void;
  onShowStyles: () => void;
}

const SubtitleHeader = ({
  availableLanguages,
  activeLanguageCode,
  preview,
  subtitlesOn,
  burnSubtitles,
  showStyles,
  showAnimations,
  showLanguageOptions,
  changingLanguage,
  activeElement,
  error,
  setShowAnimations,
  onBackStyles,
  onLanguageChange,
  onSelectTranslation,
  onShowStyles
}: SubtitleHeaderProps) => {
  const showAnimationButton = burnSubtitles && !showAnimations && activeElement;

  return (
    <>
      {error && <ErrorMessage error={error} />}
      <div className="Subtitles-Header">
        {showAnimations ? (
          <AnimationBackButton onBack={() => setShowAnimations(false)} />
        ) : (
          <SubtitleTitle
            showStyles={showStyles}
            showLanguageOptions={showLanguageOptions}
            onBackAction={onBackStyles}
          />
        )}
        {showStyles
          ? (
            <div className="Subtitles-StyleHeader">
              {!showAnimations && <BurnSubtitleOption preview={preview} />}
            </div>
          ) : subtitlesOn && (
            <SubtitleMenu
              availableLanguages={availableLanguages}
              activeLanguageCode={activeLanguageCode}
              preview={preview}
              changingLanguage={changingLanguage}
              onLanguageChange={onLanguageChange}
              onSelectTranslation={onSelectTranslation}
              onShowStyles={onShowStyles}
            />
          )}
      </div>
      {showStyles && showAnimationButton && (
        <AnimationButton onShowAnimations={() => setShowAnimations(true)} />)}
    </>
  );
};

export default SubtitleHeader;
